import { MUIDataTableColumn } from "mui-datatables";
import { InstructorModel, WorkPointModel } from "../../../Utils/Models";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { EComponentTypes } from "../../../Utils/Enums";

export const instructorClientsColumns = (
  instructors: InstructorModel[] | void
): MUIDataTableColumn[] => [
  {
    name: "productName",
    label: Vocabulary.product,
    options: {
      setCellProps: () => ({
        style: {
          position: "sticky",
          left: 0,
          background: "#fff",
          zIndex: 1000,
        },
      }),
    },
  },
  ...(instructors?.map((instructor: any) => {
    const fullName = `${instructor.firstName} ${instructor.lastName}`;
    return {
      name: fullName,
      label: fullName,
      options: {
        customBodyRender: (value: any) => {
          return value ?? 0;
        },
      },
    };
  }) ?? []),
];

/**
 * additional filters for the instructor timesheet report
 */
export const instructorClientReportFilters = (workPoints: WorkPointModel[]) => [
  {
    property: "workPointId",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.workPoint,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: workPoints,
  },
];
